import { SxProps, Theme } from '@mui/system';

const styles = {
  headerContainer: {
    marginBottom: '24px',
  },
  title: {
    fontWeight: '600',
    fontSize: 24,
    color: 'grey.800',
  },
  subtitle: {
    fontSize: 16,
    color: 'grey.600',
  },
  comparePlanButton: {
    width: '100%',
    backgroundColor: 'common.lightGreen',
    '&:hover': {
      backgroundColor: 'common.lightGreen',
      opacity: '0.8',
      boxShadow: 'none',
    },
  },
  compareLabel: {
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    color: 'primary.main',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
